import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { EXPERIMENT_SETTINGS_PROCESSING_CONFIG_LOADED, EXPERIMENT_SETTINGS_PROCESSING_ERROR } from 'redux/actionTypes/experimentSettings';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
var loadProcessingSettings = function loadProcessingSettings(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var data, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/processingConfig"));
          case 3:
            data = _context.sent;
            dispatch({
              type: EXPERIMENT_SETTINGS_PROCESSING_CONFIG_LOADED,
              payload: {
                data: data.processingConfig || data
              }
            });
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_FETCHING_DATA_PROCESSING_SETTINGS);
            dispatch({
              type: EXPERIMENT_SETTINGS_PROCESSING_ERROR,
              payload: {
                error: errorMessage
              }
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadProcessingSettings;